import React, { useState } from "react";
import { BiSearch } from "react-icons/bi";
import { HiLightningBolt } from "react-icons/hi";
import countriesWithLanguages from "../../../data/countries";
import { BsLightningChargeFill } from "react-icons/bs";
import { FaLongArrowAltRight } from "react-icons/fa";

import { ThemeContext, themes } from "../../../themes/ThemeContext";

const GenerateIdeasPanel = ({
  onSearchChange,
  setShowSearchPanel,
  setSearchQueryComplete,
  setPostData,
  postData,
  handleGetIdeas,
  handleGetIdeasOnEnter,
}) => {
  const theme = React.useContext(ThemeContext);
  const initialCountry = {
    countryCode: "US",
    languageCode: "en",
  };

  const [selectedCountry, setSelectedCountry] = useState(initialCountry);
  const [searchQuery, setSearchQuery] = useState("");
  //   const [searchQueryComplete, setSearchQueryComplete] = useState("");

  const handleCountryChange = (event) => {
    const selectedValue = event.target.value;
    const [selectedCountryCode, selectedLanguageCode] =
      selectedValue.split(":");

    setSelectedCountry({
      countryCode: selectedCountryCode,
      languageCode: selectedLanguageCode,
    });

    setPostData({
      ...postData,
      countryCode: selectedCountryCode,
      languageCode: selectedLanguageCode,
    });

    console.log("setPostData", postData);
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    onSearchChange(query);

    setPostData({
      ...postData,
      countryCode: selectedCountry.countryCode,
      languageCode: selectedCountry.languageCode,
      keyword: query,
    });
  };

  const isSearchEmpty = searchQuery.trim() === "";

  return (
    <div
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50"
      style={{ backgroundColor: "rgba(225, 225, 225, 0.3)" }}
    >
      <div
        className="w-2/6 p-5 rounded-md"
        style={{
          backgroundColor: theme.colors.background.secondary,
          color: theme.colors.text.primary,
        }}
      >
        <div className="flex justify-between">
          <div></div>
          <span
            className="text-right text-xs rounded-full h-5 w-5 flex justify-end m-auto cursor-pointer"
            style={{
              background:
                "linear-gradient(210.54deg, #9999FF 7.79%, #4B49AC 92.58%)",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              setShowSearchPanel(false);
            }}
          >
            X
          </span>
        </div>

        <div
          className="rounded-md"
          style={{ color: theme.colors.text.primary }}
        >
          <span className="flex items-center text-xs font-bold mb-5">
            <HiLightningBolt className="mr-2" color="#8C52FF" /> Get Ideas
          </span>
          <div className="w-full flex items-center">
            <div>
              <span className="text-xs">Enter a Topic</span>
              <div className="flex items-center flex-col justify-start">
                <div
                  className="w-full max-w-xs flex items-center rounded-full"
                  style={{
                    backgroundColor: theme.colors.background.secondary,
                    color: theme.colors.text.primary,
                    border: `1px solid ${theme.colors.background.accent}`,
                  }}
                >
                  <input
                    type="text"
                    placeholder="Enter a topic, brand, or product"
                    className="flex-grow bg-transparent outline-none pr-2 text-xs py-3 px-3"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onKeyDown={handleGetIdeasOnEnter}
                    // style={{
                    //   backgroundColor:
                    //     theme.colors.background.primary,
                    //   border: `1px solid ${theme.colors.background.accent}`,
                    //   color: theme.colors.text.primary,
                    // }}
                  />
                  <BiSearch className="text-gray-500 text-xs mr-3" />
                </div>
              </div>
            </div>
            <div className="ml-5">
              <span className="text-xs">Language</span>
              <div className="relative">
                <select
                  id="countrySelect"
                  className="rounded-full py-2 pl-4 pr-8 text-xs"
                  style={{
                    backgroundColor: theme.colors.background.secondary,
                    color: theme.colors.text.primary,
                    border: `1px solid ${theme.colors.background.accent}`,
                  }}
                  value={`${selectedCountry.countryCode}:${selectedCountry.languageCode}`}
                  onChange={handleCountryChange}
                >
                  <option value="US:en">United States (English)</option>
                  {countriesWithLanguages.map((item, index) => (
                    <option
                      key={index}
                      value={`${item.countryCode}:${item.languageCode}`}
                    >
                      {`${item.country} (${item.language})`}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <button
          className={`text-white rounded-full px-7 py-2 mt-5 flex items-center text-xs getIdeasBtn text-center`}
          onClick={() => {
            handleGetIdeas();
            setShowSearchPanel(false);
          }}
          disabled={isSearchEmpty}
          style={{
            background: isSearchEmpty
              ? "rgba(169, 169, 169, 0.5)" // Grayed out background
              : theme.colors.background.buttonBg,
          }}
        >
          GENERATE
          <FaLongArrowAltRight className="ml-2" color="white" />
        </button>
      </div>
    </div>
  );
};

export default GenerateIdeasPanel;
